import React from "react";
import AdminInventory from "../../components/admin/components/AdminInventory";

const Inventory = () => {
  return <AdminInventory />;
};

export default Inventory;
